import { render, staticRenderFns } from "./GatewayGamesMain.vue?vue&type=template&id=76e3ae67&scoped=true"
import script from "./GatewayGamesMain.vue?vue&type=script&lang=js"
export * from "./GatewayGamesMain.vue?vue&type=script&lang=js"
import style0 from "./GatewayGamesMain.vue?vue&type=style&index=0&id=76e3ae67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e3ae67",
  null
  
)

export default component.exports